/// <amd-module name="DistributedTask/Common/AzureResourcesService/Constants" />
export const enum DataSourceName {
    AzureKubernetesClusters = "AzureKubernetesClusters",
    KubernetesNamespaces = "KubernetesNamespaces",
    AzureResourceGroups = "AzureResourceGroups",
    AzureMachineLearningWorkspaces = "AzureMachineLearningWorkspaces",
    AzureContainerRegistries = "AzureRMContainerRegistries",
    AzureRMWebAppByResourceGroup = "AzureRMWebAppByResourceGroup",
    AzureRMWebAppSlots = "AzureRMWebAppSlots"
}

export const enum EndpointAuthorizationSchemes {
    ServicePrincipal = "serviceprincipal",
    Kubernetes = "Kubernetes"
}

export const AppToken = "AppToken";
export const AzureCloud = "AzureCloud";
export const Subscription = "subscription";
export const Azurerm = "azurerm";
export const Kubernetes = "kubernetes";
export const AzureSubscription = "AzureSubscription";
export const SPNCreationMethodManual = "Manual";
export const SPNCreationMethodAutomatic = "Automatic";